import LINKTREE from '../enums/Linktree.js';

const iconMap = {
  [LINKTREE.INSTAGRAM]: "fab fa-instagram",
  [LINKTREE.TWITTER]: "fab fa-twitter",
  [LINKTREE.FACEBOOK]: "fab fa-facebook",
  [LINKTREE.WHATSAPP]: "fab fa-whatsapp",
  [LINKTREE.YOUTUBE]: "fab fa-youtube",
  [LINKTREE.TIKTOK]: "fab fa-tiktok",
  [LINKTREE.EMAIL]: "fas fa-envelope",
  [LINKTREE.VIDEO]: "fab fa-youtube",
  [LINKTREE.ECOMMERCE]: "fas fa-globe",
  [LINKTREE.ANDROID]: "fab fa-android",
  [LINKTREE.IOS]: "fab fa-apple",
  [LINKTREE.MAPS]: "fas fa-map",
  [LINKTREE.CUSTOM]: "fas fa-link"
};

export function setIconsReport(type) {
  return iconMap[type] || null;
}
